import React from 'react'
import { Route } from 'react-router-dom'

import SistemaMenu from './SistemaMenu/SistemaMenu'
import GrupoUsuario from './GrupoUsuario/GrupoUsuario'
import Empresa from './Empresa/Empresa'
import TP from './TP/TP'
import Usuario from './Usuario/Usuario'
import CentralOperacoes from './CentralOperacoes/CentralOperacoes'
import ImportClienteMassa from './ImportClienteMassa/ImportClienteMassa'
import ImportProdutoMassa from './ImportProdutoMassa/ImportProdutoMassa'
import ImportTrechoMassa from './ImportTrechoMassa/ImportTrechoMassa'
import ImportAsscClienteEmpresa from './ImportAsscClienteEmpresa/ImportAsscClienteEmpresa'

import { auth } from '../../../services/util/auth.service'
import CelularAppExpedicao from './CelularAppExpedicao/CelularAppExpedicao'
import Permissoes from './Permissoes/Permissoes'
import PermissoesGrupoUsuario from './PermissoesGrupoUsuarios/PermissoesGrupoUsuarios'
import TipoArquivoImportacao from './TipoArquivoImportacao/TipoArquivoImportacao'
import GerarArquivoSeparacao from './GerarArquivoSeparacao/GerarArquivoSeparacao'
import AssocUsuarioOperacaoPatrimonial from './AssocUsuarioOperacaoPatrimonial/AssocUsuarioOperacaoPatrimonial'
import OperacaoMovimentacaoInsumo from './OperacaoMovimentacaoInsumo/OperacaoMovimentacaoInsumo'
import PatrimonioOwner from './PatrimonioOwner/PatrimonioOwner'
import CompaniesGroup from './CompaniesGroup/CompaniesGroup'
import ImportProdutoEanMassa from './ImportProdutoEanMassa/ImportProdutoEanMassa'
import AlterarIdentificadorDelivery from './AlterarIdentifcadorDelivery/AlterarIdentificadorDelivery'
import ConfiguracoesDeUsuarios from './ConfiguracoesDeUsuarios/ConfiguracoesDeUsuarios'
import ClienteInconsistenciaEndereco from './ClienteInconsistenciaEndereco/ClienteInconsistenciaEndereco'
import EmissorCte from './EmissorCte/EmissorCte'
import Cfop from './Cfop/Cfop'
import ImportMotoristaMassa from './ImportMotoristaMassa/ImportMotoristaMassa'
import ImportVeiculoMassa from './ImportVeiculoMassa/ImportVeiculoMassa'
import CelularAppTpDrive from './CelularAppTpDrive/CelularAppTpDrive'
import ImportVinculoRotaClienteMassa from './ImportVinculoRotaClienteMassa/ImportVinculoRotaClienteMassa'
import OcorrenciaPadraoEmpresa from './OcorrenciaPadraoEmpresa/OcorrenciaPadraoEmpresa'
import UtilizacaoSistema from './UtilizacaoSistema/UtilizacaoSistema'
import AlterarStatusPicking from './AlterarStatusPicking/AlterarStatusPicking'
import EmpresasCentralOperacoes from './EmpresasCentralOperacoes/EmpresasCentralOperacoes'
import SaldoMovimentacoesSaldoEstoque from './SaldoMovimentacoesSaldoEstoque/SaldoMovimentacoesSaldoEstoque'
import ConfiguracoesRoboXml from './ConfiguracoesRoboXml/ConfiguracoesRoboXml'
import Treinamentos from './Treinamentos/Treinamentos'

export default function Sistema() {
  return (
    <React.Fragment>
      <Route path="/main/sistema/permissoes" render={() => auth(<Permissoes />)} />
      <Route path="/main/sistema/menu" render={() => auth(<SistemaMenu />)} />
      <Route path="/main/sistema/grupo-usuario" render={() => auth(<GrupoUsuario />)} />
      <Route path="/main/sistema/usuario" render={() => auth(<Usuario />)} />
      <Route path="/main/sistema/empresa" render={() => auth(<Empresa />)} />
      <Route path="/main/sistema/tp" render={() => auth(<TP />)} />
      <Route path="/main/sistema/central-operacoes" render={() => auth(<CentralOperacoes />)} />
      <Route
        path="/main/sistema/importacao-clientes-em-massa"
        render={() => auth(<ImportClienteMassa />)}
      />
      <Route
        path="/main/sistema/importacao-produtos-em-massa"
        render={() => auth(<ImportProdutoMassa />)}
      />
      <Route
        path="/main/sistema/importacao-produtos-ean-em-massa"
        render={() => auth(<ImportProdutoEanMassa />)}
      />
      <Route
        path="/main/sistema/importacao-trechos-em-massa"
        render={() => auth(<ImportTrechoMassa />)}
      />
      <Route
        path="/main/sistema/importacao-assoc-cliente-empresa"
        render={() => auth(<ImportAsscClienteEmpresa />)}
      />
      <Route
        path="/main/sistema/celular-app-expedicao"
        render={() => auth(<CelularAppExpedicao />)}
      />
      <Route
        path="/main/sistema/permissoes-grupo-usuario"
        render={() => auth(<PermissoesGrupoUsuario />)}
      />
      <Route
        path="/main/sistema/tipos-arquivos-importacao"
        render={() => auth(<TipoArquivoImportacao />)}
      />
      <Route
        path="/main/sistema/gerar-arquivo-separacao"
        render={() => auth(<GerarArquivoSeparacao />)}
      />
      <Route
        path="/main/sistema/configurar-operacoes-patrimoniais"
        render={() => auth(<AssocUsuarioOperacaoPatrimonial />)}
      />
      <Route
        path="/main/sistema/operacoes-movimentacao-insumo"
        render={() => auth(<OperacaoMovimentacaoInsumo />)}
      />
      <Route path="/main/sistema/patrimonio-owner" render={() => auth(<PatrimonioOwner />)} />
      <Route path="/main/sistema/company-group" render={() => auth(<CompaniesGroup />)} />
      <Route
        path="/main/sistema/alterar-identificador-delivery"
        render={() => auth(<AlterarIdentificadorDelivery />)}
      />
      <Route
        path="/main/sistema/configuracoes-usuarios"
        render={() => auth(<ConfiguracoesDeUsuarios />)}
      />
      <Route
        path="/main/sistema/clientes-inconsistentes"
        render={() => auth(<ClienteInconsistenciaEndereco />)}
      />
      <Route path="/main/sistema/emissor-cte" render={() => auth(<EmissorCte />)} />
      <Route path="/main/sistema/cfop" render={() => auth(<Cfop />)} />
      <Route
        path="/main/sistema/importacao-motoristas-em-massa"
        render={() => auth(<ImportMotoristaMassa />)}
      />
      <Route
        path="/main/sistema/importacao-veiculo-em-massa"
        render={() => auth(<ImportVeiculoMassa />)}
      />
      <Route path="/main/sistema/celular-app-tp-drive" render={() => auth(<CelularAppTpDrive />)} />
      <Route
        path="/main/sistema/import-vinculo-rota-cliente-massa"
        render={() => auth(<ImportVinculoRotaClienteMassa />)}
      />
      <Route
        path="/main/sistema/ocorriencia-padrao-empresa"
        render={() => auth(<OcorrenciaPadraoEmpresa />)}
      />
      <Route
        path="/main/sistema/monitoramento-grau-utilizacao"
        render={() => auth(<UtilizacaoSistema />)}
      />
      <Route
        path="/main/sistema/alterar-status-picking"
        render={() => auth(<AlterarStatusPicking />)}
      />
      <Route
        path="/main/sistema/empresas-central-operacoes"
        render={() => auth(<EmpresasCentralOperacoes />)}
      />
      <Route
        path="/main/sistema/saldo-movimentacoes-saldo-estoque"
        render={() => auth(<SaldoMovimentacoesSaldoEstoque />)}
      />
      <Route
        path="/main/sistema/configuracoes-robo-xml"
        render={() => auth(<ConfiguracoesRoboXml />)}
      />
      <Route
        path="/main/sistema/treinamentos"
        render={() => auth(<Treinamentos />)}
      />
    </React.Fragment>
  )
}
